import { render, staticRenderFns } from "./editarAgenteDeComercio.vue?vue&type=template&id=36c88b32"
import script from "./editarAgenteDeComercio.vue?vue&type=script&lang=js"
export * from "./editarAgenteDeComercio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports